export var httpHandlerOptions = {
    bufferBody: true,
};
//# sourceMappingURL=httpHandlerOptions.native.js.map